import { useStores } from 'utility/hooks/useStores';
import { SponsoredContentLocationResolverInput } from '__generated__/api';

import { InterstitialInputs } from '@shared-ui/retail-sponsored-content-interstitial';
import { getTargetingData } from 'utility/meso-utils';

const sponsoredContentId = 'INT';

export const useInterstitialInputs = (): InterstitialInputs => {
  const {
    advertising,
    page,
    searchCriteriaStore: { searchCriteria } = {},
    searchFormStore: { searchForm } = {}
  } = useStores();

  const { destinationLocation, originLocation, departureDate, returnDate, travelersInfo } = getTargetingData(
    searchForm,
    page,
    searchCriteria
  );

  return {
    sponsoredContentContext: {
      pageName: advertising?.triggeredPageName,
      sponsoredContentId: sponsoredContentId,
      targeting: {
        origin: originLocation,
        destination: destinationLocation,
        locationResolver: SponsoredContentLocationResolverInput.TLA,
        dateStart: departureDate,
        dateEnd: returnDate,
        ...travelersInfo
      }
    }
  };
};
